import { ThemeOverride } from '@abstractTypes/theme'
import { fonts } from '@theme/index'

export const moTheme: ThemeOverride = {
  colors: {
    primaryDark: '#2B2E31',
    primaryDarkPressed: '#959798',
    primaryLight: '#FFFFFF',
    primaryLightPressed: '#F6F6F6',
    inactive: '#B0B0B0',
    outline: '#D8D8D8',
    background: '#F7F6F4',
    highlight01: '#002D73',
    highlight01Pressed: '#4091CE',
    highlight02: '#BF7E00',
    highlight02Pressed: '#FCC505',
    highlight03: '#002D73',
    highlight04: '#504BD6',
    functional01: '#BB251A',
    functional02: '#247534',
    functional03: '#F2B140',
  },
  fonts: {
    ...fonts,
    heading0: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 85,
        tablet: 68,
        tabletMini: 60,
      },
      lineHeight: {
        tower: 109,
        tablet: 86,
        tabletMini: 67,
      },
    },
    heading1: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 60,
        tablet: 56,
        tabletMini: 48,
      },
      lineHeight: {
        tower: 68,
        tablet: 62,
        tabletMini: 60,
      },
    },
    heading2: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 40,
        tablet: 40,
        tabletMini: 34,
      },
      lineHeight: {
        tower: 48,
        tablet: 48,
        tabletMini: 46,
      },
    },
    heading3: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
      },
      fontSize: {
        tower: 34,
        tablet: 34,
        tabletMini: 28,
      },
      lineHeight: {
        tower: 44,
        tablet: 44,
        tabletMini: 36,
      },
    },
    heading4: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
        bold: 700,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 36,
        tablet: 36,
        tabletMini: 30,
      },
    },
    heading5: {
      fontFamily: 'Poppins',
      weight: {
        regular: 400,
        bold: 700,
      },
      fontSize: {
        tower: 20,
        tablet: 20,
        tabletMini: 18,
      },
      lineHeight: {
        tower: 30,
        tablet: 26,
        tabletMini: 28,
      },
    },
    body: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
        bold: 700,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    label: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 14,
        tablet: 14,
        tabletMini: 12,
      },
      lineHeight: {
        tower: 24,
        tablet: 24,
        tabletMini: 18,
      },
    },
    cta: {
      fontFamily: 'Poppins',
      weight: {
        regular: 700,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    link: {
      fontFamily: 'Poppins',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 30,
        tabletMini: 26,
      },
    },
    caption: {
      fontFamily: 'Poppins',
      weight: {
        regular: 700,
      },
      fontSize: {
        tower: 13,
        tablet: 11,
        tabletMini: 11,
      },
      lineHeight: {
        tower: 16,
        tablet: 14,
        tabletMini: 14,
      },
    },
  },
  components: {
    button: {
      style: 'rounded',
      borderRadius: 64,
      uppercase: true,
    },
    rangeSlider: {
      background: '#B0B0B0', //inactive
      foreground: '#002D73', //highlight01
      thumb: '#F7F6F4', //background
      thumbBorder: '#B0B0B0', //inactive
    },
  },
}
